/*
 * This file is modeled on the Blueprint common/classes file.
 * https://github.com/palantir/blueprint/blob/develop/packages/core/src/common/classes.ts
 *
 * We're using it to add additional class constants to the BP object.
 */
let _require = require( './intent' ),
    Intent = _require.Intent;

let _require2 = require( '@nackle-bp/core' ),
    Classes = _require2.Classes;

let NS = 'np1';

Classes.getPaperNamespace = function () {
  return NS;
}; // modifiers


Classes.INTENT_INFO = Classes.intentClass( Intent.INFO ); // text utilities
// textual elements
// components

Classes.APP_ROOT = ''.concat( NS, '-app-root' );
Classes.APP_CONTAINER = ''.concat( NS, '-app-container' );
Classes.BUTTON_OUTLINE = ''.concat( NS, '-button-outline' );
Classes.GRID = ''.concat( NS, '-grid' );
Classes.GRID_COLUMN = ''.concat( NS, '-col' );
Classes.GRID_ROW = ''.concat( NS, '-row' );
module.exports = {
  Classes: Classes
};